









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class XSCam extends Vue {
  @Prop({ type: Object, required: true }) valve!: any

  // __COMPUTED
  private get xs (): any {
    return this.valve
  }
}
